import {
  PRODUCT_OFFER_REQUEST_LIST,
  PRODUCT_OFFER_REQUEST_UPDATE_LIST,
  PRODUCT_OFFER_VALUE,
} from "../actions/types";
import { initialproductOffers } from "../constants/initalStateData";

export const productOffersReducer = (state = initialproductOffers, action) => {
  switch (action.type) {
    case PRODUCT_OFFER_REQUEST_LIST:
      return {
        productOffers: action.data.productOffers,
      };

    case PRODUCT_OFFER_REQUEST_UPDATE_LIST:
      return {
        productOffers: state.productOffers.map((division) => ({
          ...division,
          productOffers: division.productOffers.map((offer) =>
            offer.product_id === action.data.changedOffer.product_id
              ? { ...offer, ...action.data.changedOffer }
              : offer
          ),
        })),
      };

    case PRODUCT_OFFER_VALUE:
      return {
        productOffers: state.productOffers.map((division) => ({
          ...division,
          productOffers: division.productOffers.map((offer) =>
            offer.product_id === action.data.offerValue.product_id
              ? {
                  ...offer,
                  offer: {
                    ...offer.offer,
                    offer: action.data.offerValue.offer,
                    offer_qty: action.data.offerValue.offer_qty,
                  },
                }
              : offer
          ),
        })),
      };
    default:
      return state;
  }
};
